import { useContext } from 'react';
import { useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { Button } from 'reaxl';
import { useFeatures } from '@atc/features';
import { EmailCTA } from 'reaxl-email';
import { DigitalRetailOverlayCTA, EsntialBuyNowCTA } from 'reaxl-wallet';
import ConfigContext from '../ConfigContext/ConfigContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
function CallsToAction(_ref) {
  let {
    activeTab,
    creditVerificationHandler,
    customCallToAction,
    saveDealXgFetcher,
    // For esntial deal
    env,
    // For saveDealXgFetcher
    digitalRetailProps,
    handleEmailCTAClick,
    hideSendOfferCTA,
    isDrEnabled,
    listing,
    // For esntial deal
    listingId,
    listingVin,
    nationalRates,
    // For esntial deal
    paymentsDuck,
    dealsDuck,
    paymentErrorState,
    zip
  } = _ref;
  const {
    dealerId,
    ecommerce,
    enableCreditVerification,
    esntialDeepLink = {}
  } = useContext(ConfigContext) || {};
  const {
    my_wallet: [, {
      enable_deals: enableDeals
    }],
    enable_ecom_cta_in_lease_tab: [enableEcomInLeaseTab]
  } = useFeatures(['my_wallet', 'enable_ecom_cta_in_lease_tab']);
  const existingDeal = useSelector(state => dealsDuck?.selectors?.getDealByListingVin(state, listingVin)) || {};
  const hasExistingDeal = enableDeals && !_isEmpty(existingDeal);
  const isLease = activeTab === 'lease';
  let showEsntialCTA = !!Object.keys(esntialDeepLink).length;

  // for syndicated use only
  const syndicatedProps = {
    dealerId,
    ecommerce
  };

  // If customCallToAction is available, disable esntialCTA and accelerate cta
  if (customCallToAction) {
    showEsntialCTA = false;
    isDrEnabled = false;
  }

  // Override Esntial on lease
  if (isLease) {
    showEsntialCTA = !!enableEcomInLeaseTab && !!Object.keys(esntialDeepLink).length;
  }

  // Configure Email CTA label
  let emailCtaLabelKey = 'calculatorOfferSummary';
  if (hasExistingDeal) {
    emailCtaLabelKey = 'calculatorDealSubmitted';
  }
  if (isLease && paymentErrorState) {
    emailCtaLabelKey = 'calculatorLeaseError';
  }
  const esntialCTA = function () {
    let bsStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'secondary';
    return /*#__PURE__*/jsx(EsntialBuyNowCTA, {
      ...esntialDeepLink,
      analyticsData: {
        listingId,
        placement: 'nds',
        tabName: activeTab
      },
      bsStyle: bsStyle,
      className: "margin-bottom-3",
      dealsDuck: dealsDuck,
      paymentsDuck: paymentsDuck,
      zip: zip,
      block: true,
      disclaimer: (() => {
        if (paymentErrorState) {
          return null;
        }
        if (isDrEnabled) {
          return 'Buy this car from the comfort of your own home including stress-free pickup or delivery!';
        }
        return 'Finalize your purchase without stepping into a dealership.';
      })(),
      nationalRates: nationalRates,
      listing: listing,
      saveDealXgFetcher: saveDealXgFetcher,
      disabled: paymentErrorState,
      env: env
    });
  };
  const handleCreditVerification = event => creditVerificationHandler(event, 'continue-button');

  /**
   * Determine which CTAs to show and return them
   */

  if (enableCreditVerification) {
    return /*#__PURE__*/jsx(Button, {
      block: true,
      bsStyle: "primary",
      className: "margin-bottom-3",
      onClick: handleCreditVerification,
      children: "Continue"
    });
  }
  if (isDrEnabled && !showEsntialCTA) {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [(!hideSendOfferCTA || hasExistingDeal) && /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
        ...digitalRetailProps,
        ...syndicatedProps,
        // for syndicated use only
        buttonStyle: "primary",
        uiContext: hasExistingDeal ? 'default' : 'lead',
        buttonText: hasExistingDeal ? 'Modify Your Deal' : null,
        route: hasExistingDeal ? 'paymentOptions' : null
      }), !hasExistingDeal && /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
        ...digitalRetailProps,
        ...syndicatedProps,
        // for syndicated use only
        buttonStyle: "secondary"
      })]
    });
  }
  if (isDrEnabled && showEsntialCTA) {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
        ...digitalRetailProps,
        buttonStyle: "secondary"
      }), esntialCTA('primary')]
    });
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!hideSendOfferCTA && /*#__PURE__*/jsx(EmailCTA, {
      listingId: listingId,
      type: "block",
      labelKey: emailCtaLabelKey,
      showIcon: false,
      className: "margin-bottom-4",
      onClick: handleEmailCTAClick,
      parentId: "FEATURED"
    }), showEsntialCTA && esntialCTA(), !!customCallToAction && customCallToAction]
  });
}
export { CallsToAction as default };
